
import {
  InstallationsSummaryMetricsSection,
  TaskSummaryMetricsSection
} from 'modules/components/layer35';
import React from 'react';



export type DashboardHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DashboardHeaderSectionProps) => {

  return (
    <>
      <InstallationsSummaryMetricsSection.FC />
      <TaskSummaryMetricsSection.FC />
    </>
  );
};
